import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

export const INSPECTION_REQUESTS_FILTER_KEY = "inspectionRequestsFilter";

export const INITIAL_INSPECTION_REQUESTS_FILTERS = {
  site_name: "",
  assigned_to: "",
  approved_by: "",
};

const InspectionRequestsFilter = ({ applyFilter, listFilterData }) => {
  const appliedValues = listFilterData?.appliedFilterValues;
  const [filterFieldsData, setFilterFieldsData] = useState(
    INITIAL_INSPECTION_REQUESTS_FILTERS
  );

  useEffect(() => {
    if (appliedValues) {
      setFilterFieldsData({
        site_name: appliedValues.site_name ?? "",
        assigned_to: appliedValues.assigned_to ?? "",
        approved_by: appliedValues.approved_by ?? "",
      });
    } else {
      setFilterFieldsData(INITIAL_INSPECTION_REQUESTS_FILTERS);
    }
  }, [
    appliedValues?.site_name,
    appliedValues?.assigned_to,
    appliedValues?.approved_by,
  ]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label="Site Name"
        type="text"
        value={filterFieldsData.site_name}
        handleChange={(value) => {
          setFilterFieldsData({ ...filterFieldsData, site_name: value });
        }}
      />
      <ConstantInput
        label="Engineer Assigned"
        type="text"
        value={filterFieldsData.assigned_to}
        handleChange={(value) => {
          setFilterFieldsData({ ...filterFieldsData, assigned_to: value });
        }}
      />
      <ConstantInput
        label="Reporting Manager"
        type="text"
        value={filterFieldsData.approved_by}
        handleChange={(value) => {
          setFilterFieldsData({ ...filterFieldsData, approved_by: value });
        }}
      />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(INITIAL_INSPECTION_REQUESTS_FILTERS);
            applyFilter(INITIAL_INSPECTION_REQUESTS_FILTERS);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

InspectionRequestsFilter.propTypes = {
  applyFilter: PropTypes.func.isRequired,
  listFilterData: PropTypes.shape({
    appliedFilterValues: PropTypes.shape({
      site_name: PropTypes.string,
      assigned_to: PropTypes.string,
      approved_by: PropTypes.string,
    }),
  }),
};

InspectionRequestsFilter.defaultProps = {
  listFilterData: null,
};

export default InspectionRequestsFilter;
